import { useCallback } from "react"
import { useSetRecoilState } from "recoil"
import { MODAL_Z_INDEX } from "../../constants"
import layoutStates from "../../recoil/atoms/layout"

const useMiniPlayerMode = () => {
  const setIsFloatingDivActive = useSetRecoilState(layoutStates.isFloatingDivActive)

  /** Enter in mini player mode */
  const enterMiniPlayerMode = useCallback(() => {

    // make the video to take 100% width and height
    const mainVideoDiv = document.getElementById(
      "main-mvw-container"
    ) as HTMLDivElement

    if(mainVideoDiv) {
      mainVideoDiv.style.zIndex = MODAL_Z_INDEX * 10 + ""
      mainVideoDiv.style.position = "fixed"
      mainVideoDiv.style.left = "0px"
      mainVideoDiv.style.bottom = "0px"
      mainVideoDiv.style.width = "100vw"
      mainVideoDiv.style.height = "100vh"
      mainVideoDiv.style.minHeight = "100%"
      mainVideoDiv.style.borderRadius = "0px"
    }

    // Set floating div active, so that it will show button on miniplayer and hide the remaining thing
    setIsFloatingDivActive(true)

  }, [setIsFloatingDivActive])

  /** Exit mini player mode */
  const exitMiniPlayerMode = useCallback(() => {

    // Remove the miniplayer style
    const mainVideoDiv = document.getElementById(
      "main-mvw-container"
    ) as HTMLDivElement

    if (mainVideoDiv) {
      mainVideoDiv.style.zIndex = null
      mainVideoDiv.style.position = null
      mainVideoDiv.style.right = null
      mainVideoDiv.style.bottom = null
      mainVideoDiv.style.width = null
      mainVideoDiv.style.height = null
      mainVideoDiv.style.borderRadius = null
      mainVideoDiv.style.overflow = null
    }

    setIsFloatingDivActive(false)


  }, [setIsFloatingDivActive])

  return {
    enterMiniPlayerMode,
    exitMiniPlayerMode
  }
}

export default useMiniPlayerMode